import BaseInsuranceCardAdapter from './base-insurance-card-adapter';

export default class UnauthenticatedInsuranceCard extends BaseInsuranceCardAdapter {
  getData(record) {
    return { 'client_id': record.attributes().clientId };
  }
}
